import EditorJsTooltip from './EditorJsTooltip';
import { InstructionAttribute, InstructionCSSClasses } from '../../components/script-editor/tools/types';
import { Project } from '../../types/items';
import { detectIOS } from '../../utility/helpers';

type TooltipParams = {
  project: Project | null;
};

class InstructionTooltip {
  protected tooltipElement: HTMLDivElement | null = null;

  protected refEditor: HTMLDivElement;

  protected editorJsTooltip: EditorJsTooltip;

  constructor({ refEditor, params }: { refEditor: HTMLDivElement; params: TooltipParams }) {
    this.editorJsTooltip = new EditorJsTooltip({ project: params.project });
    this.refEditor = refEditor;
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  init() {
    if (detectIOS()) {
      return;
    }
    this.refEditor.addEventListener('mouseover', this.showTooltip);
    this.refEditor.addEventListener('mouseout', this.hideTooltip);
  }

  destroy() {
    if (detectIOS()) {
      return;
    }
    this.refEditor.removeEventListener('mouseover', this.showTooltip);
    this.refEditor.removeEventListener('mouseout', this.hideTooltip);
  }

  protected async showTooltip(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.tooltipElement) {
      this.tooltipElement.remove();
      this.tooltipElement = null;
    }
    if (!target.classList.contains(InstructionCSSClasses.BLOCK_INSTRUCTION_ACTION)
      && !target.classList.contains(InstructionCSSClasses.INLINE_INSTRUCTION_ACTION)
    ) {
      return;
    }
    const instructionElement = target.parentElement;

    let tooltipHtml: null | string = null;

    if (instructionElement) {
      tooltipHtml = this.editorJsTooltip.getTooltip(instructionElement);
    }
    if (!tooltipHtml) {
      tooltipHtml = target.getAttribute(InstructionAttribute.tooltip);
    }

    if (!tooltipHtml) return;

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = InstructionCSSClasses.INSTRUCTION_TOOLTIP;
    this.tooltipElement.innerHTML = tooltipHtml;

    const editorOverlay = this.refEditor.querySelector('.codex-editor-overlay');
    if (editorOverlay) {
      editorOverlay.append(this.tooltipElement);
    }

    const coords = target.getBoundingClientRect();

    let left = coords.left + (target.offsetWidth - this.tooltipElement.offsetWidth) / 2;
    if (left < 0) left = 0;

    let top = coords.top - this.tooltipElement.offsetHeight - 5;
    if (top < 0) {
      top = coords.top + target.offsetHeight + 5;
    }

    this.tooltipElement.style.left = `${left}px`;
    this.tooltipElement.style.top = `${top}px`;
  }

  protected async hideTooltip(event: MouseEvent) {
    if (this.tooltipElement) {
      this.tooltipElement.remove();
      this.tooltipElement = null;
    }
  }
}

export default InstructionTooltip;
